import nacl from 'tweetnacl';
import { decodeBase64 } from 'tweetnacl-util';
import { encryptToPublicKey } from './formEncryption';

/** The app checks this exact label. It's a legacy misnomer: the construction is NaCl box. */
export const CLIENT_DATA_ALGORITHM = 'x25519-hkdf-chacha20poly1305.v1';

export interface EncryptedClientData {
  algorithm: typeof CLIENT_DATA_ALGORITHM;
  ciphertextB64: string;
  nonceB64: string;
  ephemeralPublicKeyB64: string;
}

/**
 * The key from `publicProfile/bookings`, or null if it isn't one this site can encrypt to.
 * The app writes that doc only once it can read the result, so no key means the older format.
 */
export function usableBookingKey(data: { publicKey?: unknown; algorithm?: unknown } | undefined): string | null {
  if (data?.algorithm !== CLIENT_DATA_ALGORITHM || typeof data.publicKey !== 'string') return null;
  try {
    return decodeBase64(data.publicKey).length === nacl.box.publicKeyLength ? data.publicKey : null;
  } catch {
    return null;
  }
}

export function encryptClientDetails(details: unknown, publicKeyB64: string): EncryptedClientData {
  return { algorithm: CLIENT_DATA_ALGORITHM, ...encryptToPublicKey(details, publicKeyB64) };
}
